import React from "react";
import TimeMeetingParticipantsCostHeader from "./TimeMeetingParticipantsCostHeader";
import TimeMeetingParticipantNameCell from "./TimeMeetingParticipantNameCell";
import GridHeader from "@client.components/GridHeader";
import {
  getIntegerGetter,
  getInvestmentScoreHeader,
  renderIndexValue,
} from "@client.components/DataTable/utils";

const getMeetingCostParticipateGetter = ({ data }, isCostIndexPresentation) => {
  return getIntegerGetter(
    data,
    "meetingCostParticipate",
    isCostIndexPresentation
  );
};

const getMeetingCostScheduledGetter = ({ data }, isCostIndexPresentation) => {
  return getIntegerGetter(
    data,
    "meetingCostScheduled",
    isCostIndexPresentation
  );
};

export const getMeetingParticipantsColumns = (
  t,
  maximumHours,
  maximumParticapteCost,
  isCostIndexPresentation
) => [
  {
    field: "name",
    tooltipField: "name",
    headerName: t("components.Reports.TimeMeetingParticipantsDataTable.name"),
    cellRenderer: ({ data }) => (
      <TimeMeetingParticipantNameCell rowData={data} />
    ),
    headerComponent: GridHeader,
  },
  {
    field: "hours",
    tooltipField: "hours",
    headerClass: "data-table-header header-center",
    cellClass: "data-table-cell cell-center",
    maxWidth: 100,
    headerName: t("components.Reports.TimeMeetingParticipantsDataTable.hours"),
    cellClassRules: {
      "max-value": (params) => {
        const cellValue = params.value;
        return cellValue === maximumHours;
      },
    },
    cellRenderer: ({ value }) =>
      t("components.Reports.TimeMeetingParticipantsDataTable.hoursCellFormat", {
        value,
      }),
    headerComponent: GridHeader,
  },
  {
    field: "meetingsParticipate",
    tooltipField: "meetingsParticipate",
    headerClass: "data-table-header header-center",
    cellClass: "data-table-cell cell-center",
    headerName: t(
      "components.Reports.TimeMeetingParticipantsDataTable.wmParticipate"
    ),
    headerComponent: GridHeader,
  },
  {
    field: "metingsScheduled",
    headerClass: "data-table-header header-center",
    cellClass: "data-table-cell cell-center",
    tooltipField: "metingsScheduled",
    headerName: t(
      "components.Reports.TimeMeetingParticipantsDataTable.wmScheduled"
    ),
    headerComponent: GridHeader,
  },
  {
    field: "meetingCostParticipate",
    headerClass: "data-table-header header-center",
    cellClass: "data-table-cell cell-cost-index",
    headerName: getInvestmentScoreHeader(
      t,
      "components.Reports.TimeMeetingParticipantsDataTable.mcParticipate",
      isCostIndexPresentation
    ),
    headerComponent: isCostIndexPresentation
      ? TimeMeetingParticipantsCostHeader
      : null,
    valueGetter: (v) =>
      getMeetingCostParticipateGetter(v, isCostIndexPresentation),
    tooltipValueGetter: (v) =>
      getMeetingCostParticipateGetter(v, isCostIndexPresentation),
    valueFormatter: (v) =>
      getMeetingCostParticipateGetter(v, isCostIndexPresentation),
    cellRenderer: ({ value }) =>
      renderIndexValue(value, isCostIndexPresentation),
    cellClassRules: {
      "max-value": (params) => {
        const cellValue = params.value;
        return cellValue === maximumParticapteCost;
      },
    },
  },
  {
    field: "meetingCostScheduled",
    headerClass: "data-table-header header-center",
    cellClass: "data-table-cell cell-cost-index",
    headerName: getInvestmentScoreHeader(
      t,
      "components.Reports.TimeMeetingParticipantsDataTable.mcScheduled",
      isCostIndexPresentation
    ),
    headerComponent: isCostIndexPresentation
      ? TimeMeetingParticipantsCostHeader
      : null,
    valueGetter: (v) =>
      getMeetingCostScheduledGetter(v, isCostIndexPresentation),
    tooltipValueGetter: (v) =>
      getMeetingCostScheduledGetter(v, isCostIndexPresentation),
    valueFormatter: (v) =>
      getMeetingCostScheduledGetter(v, isCostIndexPresentation),
    cellRenderer: ({ value }) =>
      renderIndexValue(value, isCostIndexPresentation),
  },
  // {
  //   field: "recommendation",
  //   tooltipField: "recommendation",
  //   headerName: t(
  //     "components.Reports.TimeMeetingParticipantsDataTable.recommendation"
  //   ),
  //   headerComponent: GridHeader,
  //   flex: 1,
  // },
];
